import $ from 'jquery';

if ($('.tax-superunie_product_cat.term-voeding').length) {
    if (sessionStorage.getItem("popup") !== "set" ) {
        $('#voeding-modal').foundation('open');
    }
}

$('.modal-save').on("click", function (){
sessionStorage.setItem("popup", "set");
});
